"use strict";
function registerMostViewed() {
    if (dataLayer && dataLayer[0] && dataLayer[0].postId) {
        var mvhostname = '//mv.larepublica.co/views/v2/al';
        $.ajax({
            url: mvhostname,
            type: "POST",
            data: JSON.stringify({
                postId: dataLayer[0].postId,
                postDate: dataLayer[0].postDateTime
            }),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function () {}
        });
    }
}
setTimeout(function() {
    registerMostViewed();
}, 20000);
